import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

// Список «К отправке»: массовый выбор строк и живое обновление статусов.
// По сообщению об окончании попытки перезагружает turbo-frame таблицы.
export default class extends Controller {
  static targets = ["row", "bulkButton", "counter"]

  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create(
      { channel: "MesDispatchChannel" },
      { received: () => this.reloadFrame() }
    )
    this.refresh()
  }

  disconnect() {
    if (this.subscription) this.subscription.unsubscribe()
  }

  toggleAll(event) {
    this.rowTargets
      .filter((checkbox) => !checkbox.disabled)
      .forEach((checkbox) => { checkbox.checked = event.target.checked })
    this.refresh()
  }

  refresh() {
    const selected = this.rowTargets.filter((checkbox) => checkbox.checked).length
    if (this.hasBulkButtonTarget) this.bulkButtonTarget.disabled = selected === 0
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = selected > 0 ? `Выбрано: ${selected}` : ""
    }
  }

  // Кадр списка отдаётся без атрибута src, а frame.reload() в этом случае —
  // пустышка: Turbo перечитывает src с элемента и, не найдя его, отменяет
  // запрос. Первое обновление поэтому выполняется присвоением src, дальше
  // кадр уже знает свой адрес и перезагружается штатно.
  reloadFrame() {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return

    if (frame.src) frame.reload()
    else frame.src = window.location.href
  }
}
